import React, {
  Fragment,
  useState,
  useEffect,
  useRef,
  useCallback,
} from "react";
import ActionBar from "./ActionBar";
import _ from "lodash";
import { navigate, useLocation } from "@reach/router";
import styled from "styled-components";
import themes from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import useLoader from "../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import CaseService from "../../../services/CaseService";
import { getErrorMessage } from "../../../helpers/functions";
import theme from "../../../assets/theme";
import AlertDialog from "../../common/Alert";
import TranscriptEditor from "../../transcripts/TranscriptEditor/index";
import AssignTranscriber from "../../pages/AssignLiveTranscribers";
import { Formik } from "formik";
import {
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  makeStyles,
} from "@material-ui/core";
import TranscriptionService from "../../../services/TranscriberService";

export const useStyles = makeStyles((themes) => ({
  formLabel: {
    fontFamily: theme.fonts.primaryFontSemiBold,
    color: COLORS.COLOR_DARK,
  },
  radioRoot: {
    margin: 15,
    [themes.breakpoints.up(640)]: {
      margin: "0px 26px",
    },
    "& .MuiTab-root": {
      padding: "5px 0",
      [themes.breakpoints.up(640)]: {
        padding: "6px 12px",
      },
    },
    "& .MuiTab-wrapper": {
      fontSize: 12,
      [themes.breakpoints.up(640)]: {
        fontSize: 16,
      },
    },
  },
}));

const TranscriptEdit = (id) => {
  const history = useLocation();
  const previousPath = history?.pathname.replace("/livetranscription", "");
  const breadcrumbs = [
    "Cases",
    `${_.capitalize(id?.type)} - ${id?.id}`,
    "Transcript",
  ];
  const [transcriptData, setTranscriptData] = useState();
  const { enqueueSnackbar } = useSnackbar();
  const { setLoader } = useLoader();
  const caseId = id?.id;
  const [data, setData] = useState([
    {
      id: "",
      start: "",
      end: "",
      text: "",
      speaker: "",
      confidence: "",
      modified: false,
      count: 0,
      mediaId: "",
      transcriptionFlag: "",
      speechFinal: "",
      utteranceEnd: "",
      lastTranscriptEndTime: "",
    },
  ]);
  const [meetingId, setMeetingId] = useState();
  const [transcriptionStatus, setTranscriptionStatus] = useState();
  const [alertMessage, setAlertMessage] = useState();
  const [dialogData, setDialogData] = useState({});
  const [open, setOpen] = useState(false);
  const [discard, setDiscard] = useState([
    {
      id: "",
      start: "",
      end: "",
      text: "",
      speaker: "",
      confidence: "",
      modified: false,
      mediaId: "",
      transcriptionFlag: "",
      speechFinal: "",
      utteranceEnd: "",
      lastTranscriptEndTime: "",
    },
  ]);
  const [refreshDetails, setRefreshDetails] = useState(true);
  const [modal, setModal] = useState({ state: false });
  const [render, setRender] = useState(false);
  const [filterSpeaker, setFilterSpeaker] = useState();
  let LiveTranscription = true;
  const [isEdited, setIsEdited] = useState(false);
  const [state, setState] = useState({ state: false });
  let interimResults = history?.state?.interim_results;
  const [endTranscriptFlag, setEndTranscriptFlag] = useState();
  const [streamingKey, setStreaminKey] = useState();
  const [meetingType, setMeetingType] = useState("plain");
  const classes = useStyles();
  const [loadingTranscript, setLoadingTranscript] = useState(false);

  const meetingTypeRef = useRef(meetingType);

  useEffect(() => {
    meetingTypeRef.current = meetingType;
  }, [meetingType]);

  useEffect(() => {
    async function getData(caseId) {
      try {
        setLoader({ state: true, message: "Fetching Transcription..." });
        const res = await CaseService.getLiveTranscriptionData(caseId);
        const transcriptionControl = await CaseService.getTranscriptionStatus(
          res?.meetingId,
        );
        setTranscriptionStatus(transcriptionControl?.transcriptionStatus);
        if (res) {
          const lastObject =
            res?.transcriptionData?.words[
              res?.transcriptionData?.words?.length - 1
            ];

          const newObject = { ...lastObject, text: "End Of Transcript" };
          if (
            res?.transcriptionData?.words?.length > 0 &&
            transcriptionControl?.endTranscript === true
          ) {
            setData([
              ...res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el.text ? el?.text : "",
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              }),
              newObject,
            ]);
            setDiscard([
              ...res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el.text ? el?.text : "",
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              }),
              newObject,
            ]);
          } else {
            setData(
              res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el?.text,
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              }),
            );
            setDiscard(
              res?.transcriptionData?.words?.map((el) => {
                return {
                  id: el?.id,
                  end: el?.end,
                  confidence: el?.confidence,
                  text: el?.text,
                  start: el?.start,
                  speaker: el?.speaker,
                  mediaId: el?.mediaId,
                  transcriptionFlag: el?.transcriptionFlag,
                  speechFinal: el?.speechFinal,
                  utteranceEnd: el?.utteranceEnd,
                  lastTranscriptEndTime: el?.lastTranscriptEndTime,
                };
              }),
            );
          }
          setMeetingId(res?.meetingId);
          setTranscriptData(res);
          setRender(true);
          setEndTranscriptFlag(transcriptionControl);
          if (res?.meetingId) {
            const streamKey = await TranscriptionService.generateRTMPLink(
              res.meetingId,
            );

            if (streamKey?.streaming_key) {
              setStreaminKey(streamKey.streaming_key);
            }
          }
        } else {
          setTranscriptData();
        }
        // getTranscriptionStatus(res?.meetingId);
      } catch (error) {
        console.log("failed");
      } finally {
        setLoader({ state: false });
        setIsEdited(false);
      }
    }
    if (refreshDetails) {
      getData(caseId);
      setRefreshDetails(false);
    }
  }, [refreshDetails]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const interval = setInterval(() => {
      getTranscriptionStatus(meetingId);
    }, 120000);
    return () => clearInterval(interval);
  }, [meetingId]); // eslint-disable-line react-hooks/exhaustive-deps

  const onBreadcrumbClick = (selected) => {
    switch (_.snakeCase(selected)) {
      case `${id?.type}_${id?.id}`:
        navigate(`${previousPath}`);
        break;
      case "cases":
        navigate(`/dashboard/case-manager/${id?.type}`);
        break;
      default:
        break;
    }
  };

  const updateLiveTranscriptionData = async (data) => {
    try {
      setLoader({ state: true, message: "Adding Transcript..." });
      /*

      let storedData = data;
      storedData.pop();
      let payload = {
        editedTranscriptionData: storedData,
        speakerNameObj: filterSpeaker,
      };
      if (state?.speakerIdendification) {
        payload = {
          editedTranscriptionData: storedData,
          speakerNameObj: filterSpeaker,
        };
      } else {
        payload = {
          editedTranscriptionData: storedData,
        };
      }

      */

      let storedData = [...data]; // use a copy to avoid mutating original
      let payload = {};
      if (
        LiveTranscription &&
        interimResults &&
        !endTranscriptFlag?.endTranscript
      ) {
        storedData = storedData.slice(0, -2);
      } else {
        storedData.pop(); // removes last item
      }
      payload = {
        editedTranscriptionData: storedData,
        id: transcriptData?.id,
        ...(state?.speakerIdendification && { speakerNameObj: filterSpeaker }),
      };

      if (storedData?.length) {
        const res = await CaseService.updateLiveTranscriptionData(
          payload,
          meetingId,
        );
        if (res?.updated) {
          setRefreshDetails(true);
        }
        if (res?.message) {
          enqueueSnackbar(res?.message, {
            variant: "success",
          });
        }
      } else {
        setRefreshDetails(true);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setState({ state: false });
    }
  };

  const getTranscriptionStatus = async (meetingId) => {
    try {
      const response = await CaseService.getTranscriptionStatus(meetingId);
      if (response) {
        setTranscriptionStatus(response?.transcriptionStatus);
        setAlertMessage(response?.alert);
      }
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    }
  };

  /*

  const mapWords = (words = []) =>
    words.map((el) => ({
      id: el?.id,
      end: el?.end,
      confidence: el?.confidence,
      text: el.text ? el?.text : "",
      start: el?.start,
      speaker: el?.speaker,
    }));

  */
  const fetchTranscriptionData = useCallback(
    async ({ showLoader = true, isPolling = false } = {}) => {
      try {
        setLoadingTranscript(true);

        if (showLoader && !isPolling) {
          setLoader({ state: true, message: "Fetching Transcription..." });
        }

        const res = await CaseService.getLiveTranscriptionData(caseId);

        if (res?.transcriptionData?.words?.length > 0) {
          const transcriptionControl = await CaseService.getTranscriptionStatus(
            res?.meetingId,
          );

          const mappedWords = res.transcriptionData.words.map((el) => ({
            id: el?.id,
            end: el?.end,
            confidence: el?.confidence,
            text: el?.text || "",
            start: el?.start,
            speaker: el?.speaker,
            mediaId: el?.mediaId,
            transcriptionFlag: el?.transcriptionFlag,
            speechFinal: el?.speechFinal,
            utteranceEnd: el?.utteranceEnd,
            lastTranscriptEndTime: el?.lastTranscriptEndTime,
          }));

          let updatedData = [...mappedWords];

          if (mappedWords.length > 0 && transcriptionControl?.endTranscript) {
            const lastObject = mappedWords[mappedWords.length - 1];

            updatedData.push({
              ...lastObject,
              text: "End Of Transcript",
            });
          }

          setData(updatedData);
          setDiscard(updatedData);
          setMeetingId(res?.meetingId ?? null);
          setTranscriptData(res);
          setEndTranscriptFlag(transcriptionControl);
        } else {
          setData([]);
          setDiscard([]);
          setMeetingId(null);
          setTranscriptData(null);
        }

        if (!isPolling && res?.meetingId) {
          const streamKey = await TranscriptionService.generateRTMPLink(
            res.meetingId,
          );

          if (streamKey?.streaming_key) {
            setStreaminKey(streamKey.streaming_key);
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingTranscript(false);
        setLoader({ state: false });
        setRender(true);
      }
    },
    [caseId, setLoader],
  );

  const moveTranscriptToDoc = async (meetingId) => {
    try {
      setLoader({ state: true, message: "Transcript moved" });
      const response = await CaseService.moveTranscriptToDoc(meetingId);
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      setTimeout(() => {
        setRefreshDetails(true);
      }, 1800);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
    }
  };

  const saveAndmoveTranscript = async (meetingId) => {
    try {
      setLoader({ state: true, message: "Transcript moved" });
      let storedData = data;
      storedData.pop();
      const payload = {
        editedTranscriptionData: storedData,
      };
      const response = await CaseService.updateLiveTranscriptionData(
        payload,
        meetingId,
      );
      if (response) {
        enqueueSnackbar(response?.message, {
          variant: "success",
        });
      }
      moveTranscriptToDoc(meetingId);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setOpen(false);
    }
  };

  const discardAndMove = (meetingId) => {
    setData(
      discard.map((el) => {
        return {
          id: el?.id,
          end: el?.end,
          confidence: el?.confidence,
          text: el?.text,
          start: el?.start,
          speaker: el?.speaker,
          mediaId: el?.mediaId,
          transcriptionFlag: el?.transcriptionFlag,
          speechFinal: el?.speechFinal,
          utteranceEnd: el?.utteranceEnd,
          lastTranscriptEndTime: el?.lastTranscriptEndTime,
        };
      }),
    );
    if (data) {
      moveTranscriptToDoc(meetingId);
    }
  };

  const moveTranscriptionAlert = (meetingId, alertMessage) => {
    setOpen(true);
    setDialogData({
      primaryBtnText: "Discard and Move",
      secondaryBtnText: "Cancel",
      moveTranscriptBtnText: "Save and Move",
      clickSecondarybtn: () => setOpen(false),
      clickPrimaryBtn: () => discardAndMove(meetingId),
      movePrimaryBtn: () => saveAndmoveTranscript(meetingId),
      onDialogClose: () => setOpen(false),
      desc: (
        <>
          Are you sure you want to move the transcript to case documents? <br />
          <br />
          <b style={{ fontFamily: `${theme.fonts.primaryFontExtraBold}` }}>
            Note :
          </b>{" "}
          <b
            style={{
              fontFamily: theme.fonts.primaryFontExtraBold,
              color: COLORS.LOGOUT_RED,
            }}
          >
            {`Please make sure you save all your changes before moving the transcript.`}
          </b>
          <br />
          <br />
          <b
            style={{
              fontFamily: theme.fonts.primaryFontExtraBold,
              color: COLORS.LOGOUT_RED,
            }}
          >
            {alertMessage}
          </b>
        </>
      ),
      moveTranscript: true,
      heading: `Move Transcription`,
      descriptionTextStyle: {
        textAlign: "left",
        fontFamily: theme.fonts.primaryFontSemiBold,
      },
    });
  };

  const discardChanges = () => {
    setData(
      discard.map((el) => {
        return {
          id: el?.id,
          end: el?.end,
          confidence: el?.confidence,
          text: el?.text,
          start: el?.start,
          speaker: el?.speaker,
          mediaId: el?.mediaId,
          transcriptionFlag: el?.transcriptionFlag,
          speechFinal: el?.speechFinal,
          utteranceEnd: el?.utteranceEnd,
          lastTranscriptEndTime: el?.lastTranscriptEndTime,
        };
      }),
    );
    setRender(true);
  };

  const actions = [
    {
      text: "Assign Transcriber",
      props: {
        onClick: () =>
          setModal({
            state: true,
            meetingId: meetingId,
            audioFileUrl: transcriptData?.audioFileUrl,
          }),
      },
      hidden: data ? false : true,
    },
    {
      text: "Post Transcript",
      props: {
        onClick: () => moveTranscriptionAlert(meetingId, alertMessage),
      },
      outlined: true,
      hidden: transcriptionStatus && data ? false : true,
    },
    {
      text: "Refresh",
      props: {
        onClick: () => setRefreshDetails(true),
      },
      outlined: true,
      // hidden: transcriptData?.audioFileUrl && data ? true : false,
    },
    {
      text: "Discard",
      props: {
        onClick: () => discardChanges(),
      },
      hidden: data ? false : true,
    },
    {
      text: "Save (alt + s)",
      props: {
        onClick: () => isEdited && updateLiveTranscriptionData(data),
      },
      hidden: data ? false : true,
    },
  ];

  const radio_inputs = [
    { label: "Raw Transcript", name: "plain", value: "plain" },
    { label: "Edited Transcript", name: "edited", value: "edited" },
  ];

  return (
    <Fragment>
      <ActionBar
        {...{
          breadcrumbs,
          onBreadcrumbClick,
          transcriptData,
          LiveTranscription,
        }}
        actions={meetingType === "edited" && data?.length ? actions : []}
      />
      <Formik
        initialValues={{ meetingType: "plain" }}
        enableReinitialize
        validateOnBlur
        validateOnChange
        onSubmit={""}
      >
        {({ values, setFieldValue }) => (
          <form>
            <Grid
              className={classes.radioRoot}
              item
              xs={12}
              spacing={2}
              style={{ marginTop: "5px", padding: 16 }}
            >
              <RadioGroup
                style={{ flexDirection: "row", marginLeft: "10px" }}
                name={"meetingType"}
                value={values.meetingType}
                onChange={(e) => {
                  const { value } = e.target;
                  setMeetingType(value);
                  meetingTypeRef.current = value;
                  setFieldValue("meetingType", value);

                  if (value === "edited") {
                    // Clear stale data and re-fetch in edited mode
                    setData([]);
                    fetchTranscriptionData({ showLoader: true });
                  } else {
                    // Switch back to raw: stop polling, re-fetch raw data
                    setData([
                      {
                        id: "",
                        start: "",
                        end: "",
                        text: "",
                        speaker: "",
                        confidence: "",
                      },
                    ]);
                    fetchTranscriptionData({ showLoader: true });
                  }
                }}
              >
                {radio_inputs.map((radio, key) => (
                  <FormControlLabel
                    key={key}
                    classes={{ label: classes.formLabel }}
                    value={radio.value}
                    control={
                      <Radio size="medium" style={{ color: "#00838c" }} />
                    }
                    label={radio.label}
                  />
                ))}
              </RadioGroup>
            </Grid>
            <Container>
              <div>
                {values?.meetingType === "edited" &&
                !loadingTranscript &&
                !data?.length ? (
                  <StyledTableEmptyBlock>
                    <h2>
                      {
                        "Welcome to JustAct live transcription services. Your session has either not started or your live transcript is currently being generated."
                      }
                    </h2>
                  </StyledTableEmptyBlock>
                ) : (
                  <TranscriptEditor
                    {...{
                      caseId,
                      meetingId,
                      render,
                      setRender,
                      setFilterSpeaker,
                      LiveTranscription,
                      isEdited,
                      setIsEdited,
                      state,
                      setState,
                      interimResults,
                      streamingKey,
                    }}
                    data={data || []}
                    endTranscript={endTranscriptFlag?.endTranscript}
                    mediaUrl={transcriptData?.audioFileUrl}
                    setData={setData}
                    title={history?.state?.title}
                    updateState={updateLiveTranscriptionData}
                    meetingType={values?.meetingType}
                  />
                )}
              </div>
            </Container>
          </form>
        )}
      </Formik>

      <AssignTranscriber {...{ modal, setModal }} />
      <AlertDialog
        isOpen={open}
        {...{ ...dialogData }}
        descriptionTextStyle={{
          textAlign: "left",
          fontFamily: theme.fonts.primaryFontSemiBold,
        }}
      />
    </Fragment>
  );
};

export default TranscriptEdit;

export const Container = styled.div`
  padding: 4px 43px;
  display: flex;
  flex-direction: column;
`;

export const HeadingContainer = styled.span`
  margin-bottom: 31px;
  font-family: ${themes.fonts.primaryFontSemiBold};
  font-size: ${(props) => (props.size ? props.size : "13px")};
  color: ${COLORS.BTN_GREEN};
  // text-transform: uppercase;
  cursor: pointer;
  & .topSection {
    background: ${COLORS.BOX_DARKGREEN};
  }
`;

const StyledTableEmptyBlock = styled.div`
  position: absolute;
  top: 55%;
  left: 55%;
  transform: translate(-40%, -40%);
  display: flex;
  flex-direction: column;
  align-items: center;
  h2 {
    color: ${COLORS.COLOR_DARK};
    font-weight: 500;
    letter-spacing: 0.1px;
    font-size: 20px;
    margin: 0;
    text-align: center;
    font-family: ${theme.fonts.primaryFontBold};
  }
  p {
    margin: 10px auto 30px;
    font-family: ${theme.fonts.primaryFontRegular};
    color: ${COLORS.COLOR_DARK};
  }
  a {
    color: ${COLORS.BTN_GREEN};
    font-family: ${theme.fonts.primaryFontRegular};
  }
`;
